const batchIdRegex = /^[0-9]{3}\/[0-9]{1,3}$/
const recordIdRegex = /^(:?32|36|27|15)[0-9]{10,11}$/

export class BatchId {
  private _batchId: string
  private _recordId: string

  constructor (batchId: string, recordId: string) {
    if (!batchIdRegex.test(batchId)) {
      throw new TypeError(`${batchId} is not a valid Batch id`)
    }
    if (!recordIdRegex.test(recordId)) {
      throw new TypeError(`${batchId} is not a valid Record id`)
    }
    this._batchId = batchId
    this._recordId = recordId
  }

  batchId (): string {
    return this._batchId
  }

  recordId (): string {
    return this._recordId
  }
}
